import { Component, OnInit, Input } from '@angular/core';
import * as moment from 'moment';
import { Eid } from 'src/app/models/eid';
import { PatientComponent } from '../patient/patient.component';

@Component({
  selector: 'app-patient-identity',
  templateUrl: './patient-identity.component.html',
  styleUrls: ['./patient-identity.component.scss']
})
export class PatientIdentityComponent extends PatientComponent implements OnInit {

  @Input() cardinfo: Eid;

  constructor() {
    super();
  }

  ngOnInit(): void {
  }

  get patientBirthday(): string {
    return moment(this.patient.birthday).format('DD/MM/YYYY');
  }

  get cardinfoBirthday(): string {
    return moment(this.cardinfo.birthday).format('DD/MM/YYYY');
  }
}
